var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPythoninline = function SvgPythoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.621 4c-2.305.011-4.506.207-6.443.55-5.707 1.006-6.743 3.11-6.743 6.994v5.128H31.92v1.71H13.374c-3.92 0-7.351 2.35-8.425 6.822-1.238 5.125-1.293 8.323 0 13.675.959 3.983 3.248 6.822 7.167 6.822h4.637v-6.148c0-4.441 3.851-8.358 8.425-8.358h13.47c3.749 0 6.742-3.08 6.742-6.838V11.544c0-3.647-3.083-6.386-6.743-6.995A42.158 42.158 0 0 0 31.621 4ZM24.33 8.125c1.393 0 2.53 1.153 2.53 2.572 0 1.413-1.138 2.556-2.53 2.556-1.398 0-2.53-1.143-2.53-2.556 0-1.419 1.132-2.572 2.53-2.572Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.184 18.298v5.93c0 4.596-3.928 8.466-8.407 8.466H25.334c-3.682 0-6.729 3.126-6.729 6.785v12.715c0 3.62 3.172 5.748 6.73 6.786 4.26 1.243 8.344 1.468 13.442 0 3.388-.973 6.729-2.932 6.729-6.786v-5.088H32.063v-1.697h20.171c3.912 0 5.37-2.707 6.73-6.77 1.405-4.182 1.345-8.205 0-13.571-.967-3.863-2.813-6.77-6.73-6.77h-5.05Zm-7.56 32.2a2.53 2.53 0 0 1 2.525 2.537c0 1.408-1.13 2.552-2.526 2.552-1.39 0-2.525-1.145-2.525-2.552a2.533 2.533 0 0 1 2.525-2.537Z",
    fill: "currentColor"
  })));
};

export default SvgPythoninline;